import {
  faCalendar,
  faCalendarWeek,
  faChevronCircleRight,
  faClock,
  faGreaterThan,
  faMapMarked,
  faMapMarker,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
// import marker from './marker.svg';
import ReactDOMServer from "react-dom/server";
import moment from "moment";
import { AirportFullName } from "../../../../service/shared/AirportFullName";
import jsPDF from "jspdf";

import html2canvas from "html2canvas";

class PaymentSummaryPdf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passengerList: this.props.location.state.pnr.passengers,
      passengerTicketInfo:
        this.props.location.state.pnr.travelPartsAdditionalDetails[0]
          .passengers,
      tripDetail: this.props.location.state.pnr.itinerary.itineraryParts,
      payments: this.props.location.state.pnr.payments,
      priceBreakdown: this.props.location.state.pnr.priceBreakdown,
      pnr: this.props.location.state.pnr.reloc,
    };
  }

  parseTime = (minute) => {
    let hours = parseInt(minute / 60);
    let minutes = minute % 60;
    return <span>{hours + "hrs " + minutes + " mins"}</span>;
  };
  parseDate = (dateString) => {
    let options = {
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    };
    let date = new Date(dateString);
    let newDate = date.toLocaleString("en-GB", options);
    return <span>{newDate}</span>;
  };
  componentDidMount() {
    html2canvas(document.querySelector("#divToPrint"), {
      logging: true,
      letterRendering: 1,
      allowTaint: true,
      useCORS: true,
    }).then((canvas) => {
      var imgData = canvas.toDataURL("image/jpeg");

      /*
      Here are the numbers (paper width and height) that I found to work. 
      It still creates a little overlap part between the pages, but good enough for me.
      if you can find an official number from jsPDF, use them.
      */
      var imgWidth = 210;
      var pageHeight = 295;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;

      var doc = new jsPDF("p", "mm");
      var position = 0;

      doc.addImage(imgData, "jpeg", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, "jpeg", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      doc.save("file.pdf");
    });

    // html2canvas(document.querySelector("#divToPrint"), {
    //   allowTaint: true,
    // }).then((canvas) => {

    // });
  }
  render() {
    return (
      <section
        className="container manage-booking-summary-print"
        id="divToPrint"
      >
        <div>
          <h3 className="pb-4 mb-3">
            <span>
              {" "}
              {this.state.passengerList[0].passengerDetails.firstName +
                " " +
                this.state.passengerList[0].passengerDetails.lastName}
              's
            </span>
            <span className="px-3">Trip Confirmation</span>
          </h3>
        </div>
        <Row>
          <Col xs={12} sm={12} md={6} lg={6}>
            <div>
              <h4>FLIGHT SUMMARY</h4>
            </div>
            <div>
              <span>
                {" "}
                {AirportFullName.getFullName(
                  this.state.tripDetail[0].segments[0].origin
                )}
              </span>
              <span className="px-3">
                <img
                  className="custom-img-sm"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA0QAAANEBqyQtcAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACrSURBVEiJzdbZbQJBDADQJxqgEghXaCIlcJdJTUBIAYmWH38sqxUiyJYYyT8zlp40hz2aptENDHHEsm/9P9E/yRd+8YPPdCCQFf5wxSIdCGTdQubpQCCbQL5fQZ5Lukdm6UAg20AumKYDgexayCQd6CBnfKQDgexbyDgd6CCnR8jLQCCHFjLqyxmoHm+5RaWHrPKaqnxoKkuFymKnslyrbDgqW6bqpi/x23IDq+uasFoBN2EAAAAASUVORK5CYII="
                />
              </span>
              <span>
                {" "}
                {this.state.tripDetail.length > 1
                  ? AirportFullName.getFullName(
                      this.state.tripDetail[this.state.tripDetail.length - 1]
                        .segments[0].origin
                    )
                  : AirportFullName.getFullName(
                      this.state.tripDetail[0].segments[
                        this.state.tripDetail[0].segments.length - 1
                      ].destination
                    )}
              </span>
            </div>
            <div>
              <span>
                {" "}
                {moment(this.state.tripDetail[0].segments[0].departure)
                  .locale(localStorage.getItem("i18nextLng"))
                  .format("dddd, MMMM DD, YYYY")}
              </span>
              <span>{" - "} </span>
              <span>
                {this.state.tripDetail.length > 1
                  ? moment(
                      this.state.tripDetail[this.state.tripDetail.length - 1]
                        .segments[0].departure
                    )
                      .locale(localStorage.getItem("i18nextLng"))
                      .format("dddd, MMMM DD, YYYY")
                  : moment(
                      this.state.tripDetail[0].segments[
                        this.state.tripDetail[0].segments.length - 1
                      ].arrival
                    )
                      .locale(localStorage.getItem("i18nextLng"))
                      .format("dddd, MMMM DD, YYYY")}
              </span>
            </div>
          </Col>
          <Col xs={12} sm={12} md={6} lg={6}>
            <div className="pnr-container">
              <div>
                <h5>CONFIRMATION CODE (PNR)</h5>
              </div>
              <div className="pnr text-center">
                <h5>{this.state.pnr}</h5>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} sm={12} md={6} lg={6}>
            <div>
              <h4>
                {" "}
                {this.state.tripDetail.length > 1 ? "ROUND TRIP" : "ONE WAY"}
              </h4>
            </div>
            <div>
              Additional details, messages, etc. can go here - configurable by
              the airline
            </div>
          </Col>
          <Col xs={12} sm={12} md={6} lg={6}>
            <div className="price-container">
              <div>
                <h4 className="py-1 price-label">TOTAL AMOUNT</h4>
                <h4 className="py-1 price-amount">
                  <span>
                    {" "}
                    {this.state.payments[0].price.alternatives[0][0].amount}
                  </span>
                  <span>
                    {" "}
                    {" " +
                      this.state.payments[0].price.alternatives[0][0].currency}
                  </span>
                </h4>
              </div>
              <div className="py-1 price-tax">
                <span>Includes taxes and fees</span>
              </div>
            </div>
          </Col>
        </Row>
        <hr className="my-4 " />
        <div className="page-break-pdf">
          <h4>FLIGHT DETAILS</h4>
        </div>
        <div className="mt-4 pagebreak">
          {this.state.tripDetail.map((trip, key) => (
            <div key={key} className="mb-3">
              {key === 0 && (
                <div className="mt-3 mb-3">
                  <span className="departure-label">
                    <b>DEPARTURE</b>
                  </span>
                  <span className="px-2">|</span>
                  <span>
                    {AirportFullName.getFullName(
                      this.state.tripDetail[key].segments[0].origin
                    )}
                  </span>
                  <span className="px-3">
                    <FontAwesomeIcon icon={faChevronCircleRight} />{" "}
                  </span>
                  <span>
                    {AirportFullName.getFullName(
                      this.state.tripDetail[key].segments[0].destination
                    )}
                  </span>
                </div>
              )}
              {key === 1 && (
                <div className="mt-3 mb-3">
                  <span className="departure-label">
                    <b>RETURN</b>
                  </span>
                  <span className="px-2">|</span>
                  <span>
                    {" "}
                    {AirportFullName.getFullName(
                      this.state.tripDetail[key].segments[0].origin
                    )}
                  </span>
                  <span className="px-3">
                    <FontAwesomeIcon icon={faChevronCircleRight} />{" "}
                  </span>
                  <span>
                    {" "}
                    {AirportFullName.getFullName(
                      this.state.tripDetail[key].segments[0].destination
                    )}
                  </span>
                </div>
              )}
              {trip.segments.map((segment, index) => (
                <div key={index}>
                  <Row className="flight-detail-row mt-4">
                    <Col xs={4}>
                      <div>
                        <span className="px-2">1</span>
                        <span className="px-2">
                          <b>DEPARTURE</b>
                        </span>
                        <span className="px-2">{segment.origin}</span>
                      </div>
                      <div>
                        <span className="px-2 d-hidden">
                          {segment.flight.airlineCode === "ET" && (
                            <img
                              className="custom-img-sm-flag"
                              src="data:image/png;base64,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"
                            />
                          )}
                        </span>
                        <span className="px-1">
                          {segment.flight.airlineCode}
                        </span>
                        <span className="pr-2">
                          {segment.flight.flightNumber}
                        </span>
                        <span className="pr-2">{segment.manufacturerName}</span>
                      </div>
                    </Col>
                    <Col xs={8}>
                      <div>
                        <span className="px-2">
                          <span className="px-1">
                            <FontAwesomeIcon icon={faCalendarWeek} />
                          </span>
                          {moment(segment.departure)
                            .locale(localStorage.getItem("i18nextLng"))
                            .format("dddd, MMMM DD, YYYY")}
                        </span>
                        <span className="px-2">
                          <span className="px-1">
                            <FontAwesomeIcon icon={faClock} />
                          </span>
                          {moment(segment.departure)
                            .locale(localStorage.getItem("i18nextLng"))
                            .format("hh:mm A")}
                          {/* 9:45pm */}
                        </span>
                      </div>
                      <div>
                        <span className="px-2">
                          <span className="px-1">
                            <FontAwesomeIcon icon={faMapMarkerAlt} />
                          </span>
                          {AirportFullName.getFullName(segment.origin)}
                        </span>
                      </div>
                    </Col>
                  </Row>
                  <Row className="py-3">
                    <Col xs={8}>
                      <Row className="duration-aircraft ml-4 py-4">
                        <Col xs={4} className="cols">
                          <div className="text-center">
                            {" "}
                            {this.parseTime(segment.duration)}
                          </div>
                        </Col>
                        {segment.manufacturerName !== null && (
                          <Col xs={4} className="cols">
                            <div className="text-center">
                              <span>AIRCRAFT</span>
                            </div>
                            <div className="text-center">
                              <span>{segment.manufacturerName}</span>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </Col>
                  </Row>
                  <Row className="flight-detail-row">
                    <Col xs={4}>
                      <div>
                        <span className="px-2"></span>
                        <span className="px-2">
                          <b>ARRIVAL</b>
                        </span>
                        <span className="px-2">{segment.destination}</span>
                      </div>
                      <div>
                        <span className="px-2 d-hidden">
                          {segment.flight.airlineCode === "ET" && (
                            <img
                              className="custom-img-sm-flag"
                              src="data:image/png;base64,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"
                            />
                          )}
                        </span>
                        <span className="px-1">
                          {segment.flight.airlineCode}
                        </span>
                        <span className="pr-2">
                          {segment.flight.flightNumber}
                        </span>
                        <span className="pr-2">{segment.manufacturerName}</span>
                      </div>
                    </Col>
                    <Col xs={8}>
                      <div>
                        <span className="px-2">
                          <span className="px-1">
                            <FontAwesomeIcon icon={faCalendarWeek} />
                          </span>
                          {moment(segment.arrival)
                            .locale(localStorage.getItem("i18nextLng"))
                            .format("dddd, MMMM DD, YYYY")}
                        </span>
                        <span className="px-2">
                          <span className="px-1">
                            <FontAwesomeIcon icon={faClock} />
                          </span>
                          {moment(segment.arrival)
                            .locale(localStorage.getItem("i18nextLng"))
                            .format("hh:mm A")}
                        </span>
                      </div>
                      <div>
                        <span className="px-2">
                          <span className="px-1">
                            <FontAwesomeIcon icon={faMapMarkerAlt} />
                          </span>
                          {AirportFullName.getFullName(segment.destination)}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
          ))}

          <hr className="my-4" />
          <br />
          <br />
          <br />
          <div>
            <div className="pb-3">
              <h4>PASSENGER DETAILS</h4>
            </div>
            {this.state.passengerTicketInfo.map((ticketInfo, index) => (
              <div key={index}>
                <div>
                  <span className="pax-counter">{index + 1}</span>
                  <span className="px-2">
                    {" "}
                    {this.state.passengerList[index].passengerDetails
                      .firstName +
                      " " +
                      this.state.passengerList[index].passengerDetails.lastName}
                    's{" "}
                  </span>
                  <span className="px-2">Trip Confirmation</span>
                </div>
                {this.state.tripDetail[index].segments.map((segment) => (
                  <div className="my-3">
                    <span className="px-2 d-hidden">
                      {segment.flight.airlineCode === "ET" && (
                        <img
                          className="custom-img-sm-flag"
                          src="data:image/png;base64,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"
                        />
                      )}
                    </span>
                    <span className="px-1">{segment.flight.airlineCode}</span>
                    <span className="pr-2">{segment.flight.flightNumber}</span>
                    <span className="pr-2">{segment.manufacturerName}</span>
                    <span className="px-2">Seat: </span>
                    <span className="px-2 float-right">
                      eTicket: {ticketInfo.eticketNumber}
                    </span>
                    <hr />
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div className="payment-detail pagebreak">
            <br />
            <br />
            <br />
            <div className="pb-3">
              <h4>PAYMENT DETAILS</h4>
            </div>
            <div>
              <span className="payment-label">Fare</span>
              {this.state.priceBreakdown.subElements[0].price.alternatives
                .length > 0 && (
                <span className="float-right">
                  {
                    this.state.priceBreakdown.subElements[0].price
                      .alternatives[0][0].amount
                  }{" "}
                  <span>
                    {" "}
                    {" " +
                      this.state.priceBreakdown.subElements[0].price
                        .alternatives[0][0].currency}
                  </span>
                </span>
              )}
            </div>
            <hr />
            <div>
              <span className="payment-label">Seat</span>
              {this.state.priceBreakdown.subElements[5].price.alternatives
                .length > 0 && (
                <span className="float-right">
                  {
                    this.state.priceBreakdown.subElements[5].price
                      .alternatives[0][0].amount
                  }{" "}
                  <span>
                    {" "}
                    {" " +
                      this.state.priceBreakdown.subElements[5].price
                        .alternatives[0][0].currency}
                  </span>
                </span>
              )}
            </div>
            <hr />
            <div>
              <span className="payment-label">Flight Extras </span>
              {this.state.priceBreakdown.subElements[4].price.alternatives
                .length > 0 && (
                <span className="float-right">
                  {
                    this.state.priceBreakdown.subElements[4].price
                      .alternatives[0][0].amount
                  }{" "}
                  <span>
                    {" "}
                    {" " +
                      this.state.priceBreakdown.subElements[4].price
                        .alternatives[0][0].currency}
                  </span>
                </span>
              )}
            </div>
            <hr />
            <div>
              <span className="payment-label">Upgrade </span>
              {this.state.priceBreakdown.subElements[7].price.alternatives
                .length > 0 && (
                <span className="float-right">
                  {
                    this.state.priceBreakdown.subElements[7].price
                      .alternatives[0][0].amount
                  }{" "}
                  <span>
                    {" "}
                    {" " +
                      this.state.priceBreakdown.subElements[7].price
                        .alternatives[0][0].currency}
                  </span>
                </span>
              )}
            </div>
            <hr />
            <div>
              <span className="payment-label">Taxes and Fee </span>
              {this.state.priceBreakdown.subElements[2].price.alternatives
                .length > 0 && (
                <span className="float-right">
                  {
                    this.state.priceBreakdown.subElements[2].price
                      .alternatives[0][0].amount
                  }{" "}
                  <span>
                    {" " +
                      this.state.priceBreakdown.subElements[2].price
                        .alternatives[0][0].currency}{" "}
                  </span>
                </span>
              )}
            </div>
            <hr />
            <div style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
              <span className="payment-label total">Total Amount </span>
              {this.state.priceBreakdown.price.alternatives.length > 0 && (
                <span className="float-right">
                  {this.state.priceBreakdown.price.alternatives[0][0].amount}{" "}
                  <span>
                    {
                      this.state.priceBreakdown.price.alternatives[0][0]
                        .currency
                    }
                  </span>
                </span>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default PaymentSummaryPdf;
